import { UntypedFormGroup } from '@angular/forms';

export function markFormAsDirty(formGroup: UntypedFormGroup) {
	formGroup.markAllAsTouched();
	const { controls } = formGroup;

	Object.keys(controls).forEach((key) => controls[key].markAsDirty());
}
